import { useBookingActivityStream } from './use-booking-activity-stream.hook';

/**
 * Headless component that activates {@link useBookingActivityStream}. Mount it once under
 * `UserProvider` (the stream is keyed on the current user) and inside `QueryClientProvider`, so a
 * booking change made on another surface refreshes this app's cache wherever the user happens to be.
 */
export const BookingActivityStream = (): null => {
  useBookingActivityStream();

  return null;
};
